import React from 'react'
import { connect } from 'react-redux'
import { AppState } from '../../../reducers/index'
import ManagerWrapper from '../ManagerWrapper'
import ManagerNavItem from './ManagerNavItem'
import { NotificationsNoneOutlined, ReportProblemOutlined, BusinessCenterOutlined, ShoppingCartOutlined, RequestQuoteOutlined, InfoOutlined, EditNotificationsOutlined, NotificationsActiveOutlined, TrendingUpOutlined, BarChartOutlined, TrackChangesOutlined, SummarizeOutlined, ListAltOutlined, QueryStatsOutlined } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { Collapse } from '@mui/material'
import { GeneralDescState } from '../../../reducers/generalDescList'
import { SessionState } from '../../../reducers/auth/session'


// Props que vienen del store
interface StateProps {
  session?: SessionState
  generalDescList?: GeneralDescState
}

// Props que vienen del padre
interface OwnProps {
  open?: boolean
  // otras props que uses desde NavMenu
}

// Combinación para el componente
type Props = StateProps & OwnProps;

const ManagerNavItems: React.FC<Props> = ({ session, generalDescList, ...props }) => {
  const { t } = useTranslation("menu");
  const [openDownload, setOpenDownload] = React.useState(false);
  const [openNotification, setOpenNotification] = React.useState(false);
  const [openGoal, setOpenGoal] = React.useState(false);

  const handleDownloadClick = () => {
    setOpenDownload(!openDownload);
  };

  const handleNotificationClick = () => {
    setOpenNotification(!openNotification);
  };


  const handleGoalClick = () => {
    setOpenGoal(!openGoal);
  };


  const isComercial = generalDescList?.generalDesc?.some(gd => gd.id === session?.categoryId && gd.code === 'com');
  const isAccounts = generalDescList?.generalDesc?.some(gd => gd.id === session?.categoryId && gd.code === 'cc');


  return <ManagerWrapper>
    <ManagerNavItem
      uri='clients'
      title={t('clients')}
      icon='people'
      {...props}
    />

    {session?.isChaco && <ManagerNavItem
      uri='people'
      title={t('people')}
      icon='contacts'
      {...props}
    />}

    <ManagerNavItem
      uri='vendors'
      title={t('vendors')}
      icon={<BusinessCenterOutlined />}
      {...props}
    />

    <ManagerNavItem
      uri='preorders'
      title={t('preorders')}
      icon={<ShoppingCartOutlined />}
      {...props}
    />

    {/* Solo visible para comerciales */}
    {isComercial && !session?.isChaco && (
      <ManagerNavItem
        uri='goals'
        title={t('goals')}
        icon={<TrackChangesOutlined />}
        nested
        onClick={handleGoalClick}
        openItem={openGoal}
        {...props}
      />)}

    {isComercial && !session?.isChaco && (
      <Collapse in={openGoal} timeout="auto" style={{
        marginTop: openGoal ? props.open ? "-16px" : "-6px" : "0px",
        marginBottom: openGoal ? props.open ? "-16px" : "-6px" : "-16px"
      }}>
        <ManagerNavItem
          uri='goals-stats-client'
          title={t('clientGoals')}
          icon={<BarChartOutlined />}
          subItem
          {...props}
        />
        <ManagerNavItem
          uri='goals-stats-vendor'
          title={t('vendorGoals')}
          icon={<TrendingUpOutlined />}
          subItem
          {...props}
        />
        <ManagerNavItem
          uri='vendorClientBrandMatrix'
          title={t('averageGoals')}
          icon={<QueryStatsOutlined />}
          subItem
          {...props}
        />
      </Collapse>)}

    <ManagerNavItem
      uri='complaints'
      title={t('complaintsList')}
      icon={<ReportProblemOutlined />}
      {...props}
    />


    {session?.isChaco && <ManagerNavItem
      uri='goals'
      title={t('goals')}
      icon={<TrackChangesOutlined />}
      nested
      onClick={handleGoalClick}
      openItem={openGoal}
      {...props}
    />}

    {session?.isChaco && <Collapse in={openGoal} timeout="auto" style={{
      marginTop: openGoal ? props.open ? "-16px" : "-6px" : "0px",
      marginBottom: openGoal ? props.open ? "-16px" : "-6px" : "-16px"
    }}>

      <ManagerNavItem
        uri='goals-stats-client'
        title={t('clientGoals')}
        icon={<BarChartOutlined />}
        subItem
        {...props}
      />
      <ManagerNavItem
        uri='goals-stats-vendor'
        title={t('vendorGoals')}
        icon={<TrendingUpOutlined />}
        subItem
        {...props}
      />
      {/*
      <ManagerNavItem
        uri='vendorClientBrandMatrix'
        title={t('brandGoals')}
        icon={<CopyrightOutlined />}
        subItem
        {...props}
      />*/}

    </Collapse>}

    <ManagerNavItem
      uri='downloads'
      title={t('downloadReport')}
      nested
      icon={<InfoOutlined />}
      onClick={handleDownloadClick}
      openItem={openDownload}
      {...props}
    />

    <Collapse in={openDownload} timeout="auto" style={{
      marginTop: openDownload ? props.open ? "-16px" : "-6px" : "0px",
      marginBottom: openDownload ? props.open ? "-16px" : "-6px" : "-16px"
    }}>
      <ManagerNavItem
        uri='dlPriceList'
        title={t('priceList')}
        icon={<RequestQuoteOutlined />}
        subItem
        {...props}
      />
      {(isComercial || isAccounts || session?.isChaco) && (<ManagerNavItem
        uri='currentAccountSummary'
        title={t('currentAccountSummary')}
        icon={<SummarizeOutlined />}
        subItem
        {...props}
      />)}

    </Collapse>

    {session?.isChaco && <ManagerNavItem
      uri='logs'
      title={t('logs')}
      icon={<ListAltOutlined />}
      {...props}
    />}

    {<ManagerNavItem
      uri='notifications'
      title={t('notifications')}
      nested
      icon={<NotificationsNoneOutlined />}
      onClick={handleNotificationClick}
      openItem={openNotification}
      {...props}
    />}

    <Collapse in={openNotification} timeout="auto" style={{
      marginTop: openNotification ? props.open ? "-16px" : "-6px" : "0px",
      marginBottom: openNotification ? props.open ? "-16px" : "-6px" : "-16px"
    }}>
      <ManagerNavItem
        uri='massNotifications'
        title={t('sendMassNotifications')}
        icon={<EditNotificationsOutlined />}
        subItem
        {...props}
      />
      <ManagerNavItem
        uri='notifications'
        title={t('notifications')}
        subItem
        icon={<NotificationsActiveOutlined />}
        {...props}
      />

    </Collapse>

  </ManagerWrapper>
}

const mapStateToProps = (state: AppState): StateProps => ({
  session: state.session,
  generalDescList: state.generalDescList
})

// Ahora TypeScript sabe que open es prop propia (OwnProps)
export default connect<StateProps, {}, OwnProps, AppState>(mapStateToProps)(ManagerNavItems);